import { fade, makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

export default makeStyles((theme) => ({
  backRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    width: "100%",
  },
  backTitle: {
    fontSize: 18,
    fontWeight: 500,
  },
  emptyText: {
    color: grey[700],
    textAlign: "center",
  },
  signOutAllBtn: {
    borderColor: theme.palette.error.main,
    color: theme.palette.error.main,
    width: 255,
    padding: theme.spacing(0.85, 1),
  },
  signOutAllIcon: {
    fill: theme.palette.error.main,
  },
  rowCard: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    width: "100%",
    padding: theme.spacing(1.5),
    borderRadius: theme.spacing(1),
    backgroundColor: grey[50],
  },
  iconBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    width: 40,
    height: 40,
    borderRadius: theme.spacing(1),
    backgroundColor: fade(theme.palette.primary.main, 0.08),
  },
  rowContent: {
    flex: 1,
    minWidth: 0,
  },
  rowTitle: {
    color: theme.palette.common.black,
    fontSize: 16,
  },
  rowSubtitle: {
    color: grey[500],
    fontSize: 12,
  },
}));
